<mat-toolbar>
  <div class="container">
    <span class="customer-header-logo"> S9 </span>
    <div class="right-side-menu">
      <!-- <div [class.spinner]="loading"></div> -->
      <span><img matTooltip="Notifications" src="assets/img/bell.svg" />
        <p class="notification">{{ totalIndex }}</p>
      </span>
      <div class="dropdown" matTooltip="Profile" style="cursor: pointer">
        <a mat-button [matMenuTriggerFor]="menu"><img class="header-profile"
            src="{{ profilePic ? profilePic : 'assets/img/profilesimg.svg' }}" />Hi,
          {{ userName }}
          <span style="text-transform: capitalize"></span>
        </a>

        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="GoToProfile()">Profile</button>
          <div class="seperator"></div>
          <button mat-menu-item (click)="GoToTasks()">Tasks</button>
          <div class="seperator"></div>
          <button mat-menu-item (click)="GoToLogout()">Logout</button>
        </mat-menu>
      </div>
    </div>
  </div>
</mat-toolbar>
<div class="container admin-profile">
  <p class="breadcrums arrow" (click)="GoToDashboard()">
    <span class="material-icons">arrow_back_ios_new</span>
    Back to Dashboard
  </p>

  <!-- Tab bar -->
  <div class="activity-tabs" style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
    <div style="display: flex; gap: 24px;">
      <a [ngClass]="{ active: activeTab === 'all' }" (click)="activeTab = 'all'">All</a>
      <a [ngClass]="{ active: activeTab === 'driver' }" (click)="activeTab = 'driver'">Driver</a>
      <a [ngClass]="{ active: activeTab === 'truckowner' }" (click)="activeTab = 'truckowner'">Truck Owner</a>
    </div>
    <div class="search-container" style="margin-right: 15px; display: flex; align-items: center; background: #ededed; border-radius: 7px; padding-right: 10px;">
      <input type="text" placeholder="Search by name or mobile..." [(ngModel)]="searchTerm" (keyup.enter)="onSearch()" class="form-control" style="width: 250px; border: none; background: transparent; outline: none; box-shadow: none; display: inline-block;">
      <span class="material-icons" style="cursor: pointer; color: #f58634;" (click)="onSearch()">search</span>
    </div>
  </div>

  <div class="row mt-3 align-items-center justify-content-center">
    <div class="row to_container" *ngIf="
        ActivityData?.driver?.length === 0 &&
        ActivityData?.truckowner?.length === 0
      ">
      <h4 class="error_msg">No Records Found.</h4>
    </div>
    <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12" *ngIf="
        ActivityData?.driver?.length > 0 || ActivityData?.truckowner?.length > 0
      ">
      <table class="table table-bordered border table-hover table-sm mt-3 text-center">
        <thead class="table-header bg-light">
          <tr>
            <th>ID</th>
            <th>User</th>
            <th>Name</th>
            <th>Mobile No</th>
            <th>Date of Registration</th>
            <th>View Details</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody class="table-body table-striped text-capitalize table-hover text-center">
          <!-- Driver Approval -->
          <tr *ngFor="let item of ActivityData.driver" [hidden]="activeTab === 'truckowner'">
            <td>{{ item.driver_id }}</td>
            <td>{{ item.loginInfo[0]?.user_type }}</td>
            <td>{{ item.username }}</td>
            <td>{{ item.mobile }}</td>
            <td>{{ item.createdAt | date : "dd-MM-yyyy" }}</td>
            <td>
              <button class="btn" mat-button (click)="viewDetails(item)">
                View
              </button>
            </td>
            <td>
              <button class="btn text-success" mat-button (click)="activityStatus(item, statusAvailable)">
                Approve
              </button>
            </td>
            <td>
              <button class="btn text-danger" mat-button (click)="activityStatus(item, statusRejected)">
                Reject
              </button>
            </td>
          </tr>

          <!-- Truck Owner Approval -->
          <tr *ngFor="let item of ActivityData.truckowner" [hidden]="activeTab === 'driver'">
            <td>{{ item.truckowner_id }}</td>
            <td>{{ item.loginInfo[0]?.user_type }}</td>
            <td>{{ item.username }}</td>
            <td>{{ item.mobile }}</td>
            <td>{{ item.createdAt | date : "dd-MM-yyyy" }}</td>
            <td>
              <button class="btn" mat-button (click)="viewDetails(item)">
                View
              </button>
            </td>
            <td>
              <button class="btn text-success" mat-button (click)="activityStatus(item, statusAvailable)">
                Approve
              </button>
            </td>
            <td>
              <button class="btn text-danger" mat-button (click)="activityStatus(item, statusRejected)">
                Reject
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div [class.spinner]="loading"></div>
</div>